import { wrapMethodsWithLogging } from "../../../components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "../../../repositories/api/BaseApiRepository";
import { IExemptionApplicationChangeType, IExemptionApplicationHistoryQuery, IExemptionApplicationProcessDecision, IExemptionApplicationProcessRecommendation } from "../dtos/Interfaces";

export interface IExemptionApplicationRepository {
    getRecommendationTypeGroupsAsync(): Promise<Response>;
    getDecisionTypeGroupsAsync(): Promise<Response>;
    getLimitingConditionsForDecisionAsync(): Promise<Response>;
    getIncompleteForRecommendationAsync(): Promise<Response>;
    getIncompleteForDecisionAsync(): Promise<Response>;
    getApplicationByIdAsync(id: number): Promise<Response>;
    searchHistoryAsync(query: IExemptionApplicationHistoryQuery): Promise<Response>;
    updateRecommendationApplicationAsync(id: number, data: IExemptionApplicationProcessRecommendation): Promise<Response>;
    changeApplicationTypeAsync(id: number, data: IExemptionApplicationChangeType): Promise<Response>;
    updateDecisionApplicationAsync(id: number, data: IExemptionApplicationProcessDecision): Promise<Response>;
    getDocumentByIdAsync(id: number): Promise<Response>;
    getSmsReceiverAsync(): Promise<Response>;
    updateSmsReceiverAsync(): Promise<Response>;
    searchAsync(query: SearchQueryProps): Promise<Response>;
    reprocessAsync(id: number): Promise<Response>;
}

class ExemptionApplicationRepository implements IExemptionApplicationRepository {

    _baseUrl = "exemption-application/";

    async getRecommendationTypeGroupsAsync() {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}recommendation-type-groups`);
        return reponse as Response;
    }

    async getDecisionTypeGroupsAsync() {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}decision-type-groups`);
        return reponse as Response;
    }

    async getLimitingConditionsForDecisionAsync() {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}limiting-conditions-for-decision`);
        return reponse as Response;
    }

    async getIncompleteForRecommendationAsync() {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}incomplete/recommendation`);
        return reponse as Response;
    }

    async getIncompleteForDecisionAsync() {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}incomplete/decision`);
        return reponse as Response;
    }
    
    async getApplicationByIdAsync(id: number) {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}${id}`);
        return reponse as Response;
    }

    async searchHistoryAsync(query: IExemptionApplicationHistoryQuery) {
        const reponse = await BaseApiRepository.postAsync(`${this._baseUrl}history`, query);
        return reponse as Response;
    }

    async updateRecommendationApplicationAsync(id: number, data: IExemptionApplicationProcessRecommendation) {
        const reponse = await BaseApiRepository.putAsync(`${this._baseUrl}${id}/recommendation`, data);
        return reponse as Response;
    }

    async changeApplicationTypeAsync(id:number, data:IExemptionApplicationChangeType) {
        const reponse = await BaseApiRepository.putAsync(`${this._baseUrl}${id}/change-application-type`, data);
        return reponse as Response;
    }

    async updateDecisionApplicationAsync(id: number, data: IExemptionApplicationProcessDecision) {
        const reponse = await BaseApiRepository.putAsync(`${this._baseUrl}${id}/decision`, data);
        return reponse as Response;
    }

    async getDocumentByIdAsync(id: number) {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}documents/${id}`);
        return reponse as Response;
    }

    async getSmsReceiverAsync() {
        const reponse = await BaseApiRepository.getAsync(`${this._baseUrl}sms-receiver`);
        return reponse as Response;
    }

    async updateSmsReceiverAsync() {
        const reponse = await BaseApiRepository.putAsync(`${this._baseUrl}sms-receiver`);
        return reponse as Response;
    }

    async searchAsync(query: SearchQueryProps) {
        const reponse = await BaseApiRepository.postAsync(`${this._baseUrl}search`, query);
        return reponse as Response;
    }

    async reprocessAsync(id:number) {
        const reponse = await BaseApiRepository.putAsync(`${this._baseUrl}${id}/reprocess`);
        return reponse as Response;
    }
}
 
wrapMethodsWithLogging(ExemptionApplicationRepository);

export default ExemptionApplicationRepository;
